<template>
  <div class="content-pagination">
      <div class="page prev" @click="(page > 0) && setPage(page - 1)">Previous</div>
      <div v-if="page > (showPages)" class="page" @click="(page > 0) && setPage(0)">1</div>
      <div v-if="page > (showPages + 1)" class="placeholder">...</div>
      <div
          v-for="p in paginationRange"
          :key="p"
          :class="{ page: true, active: page === p }"
            @click="(page !== p) && setPage(p)"
      >
          {{ (p + 1) }}
      </div>
      <div v-if="page < (lastPage - showPages - 1)" class="placeholder">...</div>
      <div v-if="page < (lastPage - showPages)" class="page" @click="(page < lastPage) && setPage(lastPage)">{{ lastPage + 1 }}</div>
      <div class="page next" @click="setPage(page + 1)">Next</div>
  </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        showPages: {
            type: Number,
            default: 3,
        },
        module: {
            type: String,
            required: true,
        },
        payload: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
        };
    },
    computed: {
        page() {
            return this.$store.state[this.module].page;
        },
        pagesize() {
            return this.$store.state[this.module].pagesize;
        },
        count() {
            return this.$store.state[this.module].count;
        },
        list() {
            return this.$store.state[this.module].list;
        },
        lastPage() {
            return Math.ceil(this.count / this.pagesize) - 1;
        },
        firstPage() {
            return 0;
        },
        loopStart() {
            let loopStart = this.page - this.showPages;
            if (loopStart < 0) {
                loopStart = 0;
            }
            return loopStart;
        },
        loopEnd() {
            let loopEnd = this.page + this.showPages;
            if (loopEnd > this.lastPage) {
                loopEnd = this.lastPage;
            }
            return loopEnd;
        },
        paginationRange() {
            return new Array(this.loopEnd - this.loopStart + 1).fill(this.loopStart).map((n, i) => n + i);
        },
    },
    watch: {
        payload: {
            handler(val) {
                console.log('sss', val);
                this.setPage(0);
            },
            deep: true,
        },
    },
    async created() {
        const data = Object.assign({}, this.payload, { page: 0 });
        await this.$store.dispatch(`${ this.module }/list`, data);
    },
    methods: {
        setPage(page) {
            if (page >= 0 && page <= this.lastPage) {
                const data = Object.assign({}, this.payload, { page });
                this.$store.dispatch(`${ this.module }/list`, data);
            }
        },
    },
};
</script>
